// extracted by mini-css-extract-plugin
module.exports = {"root":"VideosList-module--root--L3dga","inner":"VideosList-module--inner--31JPT","wrap":"VideosList-module--wrap--2x6bu","news":"VideosList-module--news--2cSJK"};